// Chat UI surface. Lives in shared/ so every app pulling shared/context.js
// (canvas, workspace-project, future embeds) gets ChatMain, ChatComposer,
// ChatSidebar, ChatThreadPanel etc. via key reference automatically.
//
// Page-level surfaces (Main, Sidebar, SearchPanel, MentionDropdown, modals)
// are exported here and used inside workspace-project's /chat route via
// `extends`. Embed-level surfaces (MessageList, Composer, ChatHover*) are
// what ChatDrawer in canvas extends. All resolve via the same registry.

export * from './Sidebar.js'
export * from './Main.js'
export * from './MessageList.js'
export * from './Composer.js'
export * from './NewChannelModal.js'
export * from './ChannelSettingsModal.js'
export * from './ThreadPanel.js'
export * from './SearchPanel.js'
export * from './MentionDropdown.js'
export * from './Tabs.js'
export * from './ChatCode.js'
export * from './SidebarDropdown.js'
export * from './RenameModal.js'
